import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=41b5f490"
import script from "./RecentActivity.vue?vue&type=script&lang=js"
export * from "./RecentActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports